import { Col, Container, Row } from 'react-bootstrap';
import Avatar, {
  AvatarIndicator,
  AvatarParams,
  AvatarSize,
  AvatarStatus,
} from './Avatar';
import AvatarGroup, { AvatarGroupSize, AvatarGroupStyle } from './AvatarGroup';

export const avatars: AvatarParams[] = [
  {
    id: '1',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: false,
  },
  {
    id: '2',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: true,
  },
  {
    id: '3',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: true,
  },
  {
    id: '4',
    image: '',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: true,
  },
  {
    id: '5',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: true,
  },
  {
    id: '6',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: true,
  },
  {
    id: '7',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: true,
  },
  {
    id: '8',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: true,
  },
  {
    id: '9',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Ivanov',
    hasTooltip: true,
  },
  {
    id: '10',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Test Name',
    hasTooltip: true,
  },
  {
    id: '11',
    image: 'conduent_profile.jpeg',
    status: AvatarStatus.ENABLED,
    size: AvatarSize.EXTRA_SMALL,
    name: 'Daniel Ivanov',
    hasTooltip: true,
  },
];

const AvatarDemo = ({ children }: any) => {
  return (
    <Container>
      <Row>
        <Col>
          <h3>Avatars</h3>
        </Col>
        <Col>
          <h3>Avatar Groups</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Avatar
            id={'4'}
            image={'conduent_profile.jpeg'}
            status={AvatarStatus.ENABLED}
            size={AvatarSize.LARGE}
            indicator={AvatarIndicator.DEFAULT}
            name={'Test Name'}
            onClick={() => console.log('Clicked Avatar')}
          />
          <Avatar
            id={'4'}
            image={'conduent_profile.jpeg'}
            status={AvatarStatus.ENABLED}
            size={AvatarSize.MEDIUM}
            indicator={AvatarIndicator.SUCCESS}
            name={'Test Name'}
            onClick={() => console.log('Clicked Avatar')}
          />
          <Avatar
            id={'5'}
            image={'conduent_profile.jpeg'}
            status={AvatarStatus.DISABLED}
            size={AvatarSize.MEDIUM}
            name={'Test Name'}
          />
          <Avatar
            id={'6'}
            image={''}
            status={AvatarStatus.DISABLED}
            size={AvatarSize.SMALL}
            indicator={AvatarIndicator.FAILED}
            name={'Daniel Ivanov'}
          />
          <Avatar
            id={'7'}
            image={''}
            status={AvatarStatus.DISABLED}
            size={AvatarSize.EXTRA_SMALL}
            name={'Test Name'}
          />
          <h3>Avatars with Tooltip</h3>
          <Avatar
            id={'4'}
            image={'conduent_profile.jpeg'}
            status={AvatarStatus.ENABLED}
            size={AvatarSize.LARGE}
            indicator={AvatarIndicator.DEFAULT}
            name={'Test Name'}
            onClick={() => console.log('Clicked Avatar')}
            hasTooltip
          />
          <Avatar
            id={'4'}
            image={'conduent_profile.jpeg'}
            status={AvatarStatus.ENABLED}
            size={AvatarSize.MEDIUM}
            indicator={AvatarIndicator.SUCCESS}
            name={'Test Name'}
            onClick={() => console.log('Clicked Avatar')}
            hasTooltip
          />
          <Avatar
            id={'5'}
            image={'conduent_profile.jpeg'}
            status={AvatarStatus.DISABLED}
            size={AvatarSize.MEDIUM}
            name={'Test Name'}
            hasTooltip
          />
          <Avatar
            id={'6'}
            image={''}
            status={AvatarStatus.DISABLED}
            size={AvatarSize.SMALL}
            indicator={AvatarIndicator.FAILED}
            name={'Daniel Ivanov'}
            hasTooltip
          />
          <Avatar
            id={'7'}
            image={''}
            status={AvatarStatus.DISABLED}
            size={AvatarSize.EXTRA_SMALL}
            name={'Test Name'}
            hasTooltip
          />
        </Col>
        <Col>
          <AvatarGroup
            avatars={avatars}
            groupSize={AvatarGroupSize.MINIMIZED}
            groupStyle={AvatarGroupStyle.DEFAULT}
          />
          <AvatarGroup
            avatars={avatars}
            groupSize={AvatarGroupSize.DEFAULT}
            groupStyle={AvatarGroupStyle.DEFAULT}
          />
          <AvatarGroup
            avatars={avatars}
            groupSize={AvatarGroupSize.DEFAULT}
            groupStyle={AvatarGroupStyle.STACKED}
          />
          <AvatarGroup
            avatars={avatars}
            groupSize={AvatarGroupSize.DEFAULT}
            groupStyle={AvatarGroupStyle.STACKED}
          />
        </Col>
      </Row>
      <Row>
        <h3>Avatar Groups with Tooltip</h3>
        <AvatarGroup
          avatars={avatars}
          groupSize={AvatarGroupSize.DEFAULT}
          groupStyle={AvatarGroupStyle.STACKED}
          hasTooltip
        />
      </Row>
    </Container>
  );
};

export default AvatarDemo;
